import script from "./NotificationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsList.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsList.vue?vue&type=style&index=0&id=0a224cac&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a224cac"]])

export default __exports__